"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
const core_1 = require("@angular/core");
const common_1 = require("../../@inax/common");
const inaxSignalR_1 = require("../../@inax/common/src/signalR/inaxSignalR");
const motion_1 = require("../../@inax/motion/src/motion");
const translate_1 = require("../../@inax/translate/src/translate");
let AppComponent = class AppComponent {
    constructor(_signalR, _motionService, _translator) {
        this._signalR = _signalR;
        this._motionService = _motionService;
        this._translator = _translator;
        this.title = 'INAX HMI';
        this.disablerOverlayActive = false;
        this._motionService.HmiId = 3;
        this._translator.language = "en-GB";
        let init = this._signalR.isInitialized;
        if (this._signalR != null && this._signalR.isInitialized) {
            // Let's wire up to the signalr observables
            //
            this.connectionState = this._signalR.connectionState
                .map((state) => { return common_1.ConnectionState[state]; });
            this._signalR.error.subscribe((error) => { console.warn(error); }, (error) => { console.error("errors$ error", error); });
            // Wire up a handler for the starting$ observable to log the
            //  success/fail result
            //
            this._signalR.starting.subscribe(() => { console.log("signalr service has been started"); }, () => { console.warn("signalr service failed to start!"); });
        }
    }
    inView(event) {
        console.log(event);
    }
};
AppComponent = __decorate([
    core_1.Component({
        selector: 'inax-base-app',
        styleUrls: ['app/components/app.component.css'],
        template: `
    <div class="cockpit">
      <h1>{{title}}</h1>
      <br/>
      <inax-date-time format2=""></inax-date-time>
      <nav>
        <a [routerLink]="['/home']">Home</a>
        <a [routerLink]="['/plcviewer']">Plc</a>
        <a [routerLink]="['/sqlviewer']">Sql</a>
        <a [routerLink]="['/scriptviewer']">Script</a>
        <a [routerLink]="['/alarms/historical']">Historical Alarms</a>
        <a [routerLink]="['/alarms/pending']">Pending Alarms</a>
        <a [routerLink]="['/motion/1100']">Motions</a>
        <a [routerLink]="['/configuration']">Configuration</a>
        <a [routerLink]="['/testpage']">Testpage</a>
        <a [routerLink]="['/login']">Login/out</a>
      </nav>
    <alarm-line></alarm-line>
    </div>
    <div class="container-fluid">
      <div class="col-sm-12 col-sm-offset-0 col-md-12 col-md-offset-0 col-lg-12 col-lg-offset-0 main inax-mainview">
        <router-outlet></router-outlet>
        <!--<inax-disabler-overlay [active]="disablerOverlayActive"></inax-disabler-overlay>-->
        <user-login></user-login>
        <button-menu class="navbar navbar-fixed-bottom navbar-inverse"></button-menu>
      </div>
    </div>
  `
    }),
    __metadata("design:paramtypes", [inaxSignalR_1.InaxSignalR,
        motion_1.InaxMotionService,
        translate_1.InaxTranslateService])
], AppComponent);
exports.AppComponent = AppComponent;
